import { render, staticRenderFns } from "./index.vue?vue&type=template&id=da7229f0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=da7229f0&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=da7229f0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da7229f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da7229f0')) {
      api.createRecord('da7229f0', component.options)
    } else {
      api.reload('da7229f0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=da7229f0&scoped=true", function () {
      api.rerender('da7229f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/index.vue"
export default component.exports